import _find from "lodash/find";
import mainSelectors from "../main/selectors";
import paymentSelectors from "modules/payment/selectors";
import { useSelector } from "react-redux";

const useCurrency = () => {
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const remainingBudgetList = useSelector((state) => paymentSelectors.remainingBudgetList(state));
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const selectedAdsData = _find(authAdproResult.data.ads, { ads_account_id: currentAd.ads_account_id });
  const currencyCode = remainingBudgetList.creditCard ? "" : selectedAdsData ? selectedAdsData.currency_code : "THB";

  return currencyCode;
};

export default useCurrency;
